import React from "react";
import { useEffect, useState } from "react";
import ResctrictImg from "../src/Assets/restrict.png"

const DeviceRestriction = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width > 1024); // Adjust breakpoint as needed
    };

    checkDevice(); // Initial check
    window.addEventListener("resize", checkDevice); // Listen for resize

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return isMobile ? (
    children
  ) : (
    <div className="restrictionContainer">
        <img src={ResctrictImg} alt="" srcset="" />
      <h1>Access Restricted</h1>
      <p>
        This Application is not Accessible on Tablets / Mobile Devices.
      </p>
    </div>
  );
};

export default DeviceRestriction;
